<template>
  <div class="v-input v-input--selection-controls v-input--hide-details">
    <div class="v-input__control">
      <div class="v-input__slot" :title="title">
        <div class="v-input--selection-controls__input" @click="$emit('input', !value)">
          <div class="v-input--selection-controls__ripple primary--text"></div>
          <i class="v-icon mdi mdi-add theme--light" :style="colorStyle" :class="checkedClass"></i>
        </div>
        <div class="v-label theme--light d-inline-block" @click="$emit('input', !value)">
          <label class="d-inline clickable" style="left: 0; right: auto; position: relative" v-if="!$slots.default">{{ text }}</label>
          <slot v-else></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'text', 'color', 'title'],
  computed: {
    checkedClass() {
      return (this.value ? ('mdi-checkbox-marked --text') : 'mdi-checkbox-blank-outline theme-light');
    },
    colorStyle() {
      return this.value ? { color: this.color || '#11697d' } : null;
    }
  },
}
</script>

<style scoped>
.v-input {
  padding-top: 0;
  margin-top: 0;
}
</style>